<template>
  <div class="jobs-list" v-loading="loader">
    <el-input placeholder="Поиск ..." v-model="search" class="input-search">
      <el-button slot="append" icon="el-icon-search"></el-button>
    </el-input>
    <draggable
      class="jobs-ul"
      handle=".handle"
      :list="versions" @change="save"
    >
      <div
        class="jobs-li" v-for="(version, index) in filteredList" :key="index"
      >
        <div class="name handle">
          <i class="fa fa-align-justify"></i>
          <span>{{ version.name ||  version.label}}</span>
        </div>
        <router-link :to="`/dashboard/versions/${version.id}/edit`">
          <i  class="fa fa-edit"></i>
        </router-link>
      </div>
    </draggable>
    <router-link :to="`/dashboard/versions/create/`" class="add-job">
      <el-button>+ Добавить</el-button>
    </router-link>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import draggable from 'vuedraggable';
import {getVersions} from '../../../firestore/versions';

export default {
  name: 'List',
  components: {draggable},

  data() {
    return {
      loader: false,
      search: '',
      versions: [],
    };
  },

  mounted() {
    this.fetchJobs();
  },

  methods: {
    save: _.debounce(function (el, binding) {
      const versions = this.versions.map((unit, index) => {
        return {
          ...unit,
          _data: {
            ...unit._data,
            index: index,
          },
        };
      });

      this.update(versions);
    }, 1000),

    async fetchJobs() {
      this.loader = true;

      this.versions = await getVersions(this.$store.state.project.id);

      this.loader = false;
    },
    update(works) {
      let batch = firebase.firestore().batch();
      works.forEach((doc) => {
        const docRef = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(doc.id);
        batch.update(docRef, doc._data);
      });
      batch.commit();
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(id).delete()
          .then((data) => {
            this.$emit('update');
            this.fetchJobs();
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
  },

  computed: {
    filteredList() {
      return this.versions.filter(version => {
        return (version.name || version.label).toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;

    color: #000;
    text-decoration: none !important;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.fa-trash {
  margin-right: 15px;
}

.name {
  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Versions/Index.vue